const moduleState = () => {
  return {
    dictionaryLoaded: false,
  }
}
const getters = {
  dictionaryLoaded: (state) => state.dictionaryLoaded,
}

const mutations = {
  setDictionaryLoaded: (state) => {
    state.dictionaryLoaded = true
  },
}

export default {
  state: moduleState,
  getters,
  mutations,
  namespaced: true,
}
